import { Configuration, ProtocolMode } from '@azure/msal-browser';
import { IS_PROD } from 'env';

const getOIDCConfig = ({
    issuer,
    clientId,
}: {
    issuer: string;
    clientId: string;
}): Configuration => ({
    auth: {
        protocolMode: ProtocolMode.OIDC,
        authorityMetadata: JSON.stringify({
            authorization_endpoint: `${issuer}/protocol/openid-connect/auth`,
            token_endpoint: `${issuer}/protocol/openid-connect/token`,
            issuer,
            userinfo_endpoint: `${issuer}/protocol/openid-connect/userinfo`,
        }),
        authority: issuer,
        clientId,
        knownAuthorities: [issuer],
        redirectUri: `${window.location.origin}/login`,
    },
});

const AMP_TEST_ISSUER =
    'https://appidpm-t.ampmetropole.fr/auth/realms/Extranet';
const AMP_TEST_CLIENT_ID = 'MANTY_TEST';

export const OIDC_CONFIG_FOR_BIND = {
    cove: getOIDCConfig({
        issuer: 'https://auth.lacove.fr/realms/externe',
        clientId: 'manty',
    }),
    ampmetropole: getOIDCConfig({
        // TODO: If you see this snippet after may 2025, you can safely remove the AMP_TEST case from `ampmetropole`
        // we keep it for now because we want them to be able to keep using the "client staging" env while we
        // migrate their test bind to the brand new "amp_recette" that sits on the prod environment
        issuer: IS_PROD
            ? 'https://authentification.ampmetropole.fr/auth/realms/Extranet'
            : AMP_TEST_ISSUER,
        clientId: IS_PROD ? 'MANTY' : AMP_TEST_CLIENT_ID,
    }),
    amp_recette: getOIDCConfig({
        issuer: AMP_TEST_ISSUER,
        clientId: AMP_TEST_CLIENT_ID,
    }),
} as const;

type OIDCBind = keyof typeof OIDC_CONFIG_FOR_BIND;

export const isBindUsingOIDC = (bind: string): bind is OIDCBind =>
    Object.keys(OIDC_CONFIG_FOR_BIND).includes(bind);
